module.exports = __webpack_public_path__ + "static/img/10.01c8747.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/10.png
// module id = B6jg
// module chunks = 0